export default __webpack_public_path__ + "static/media/pin.ba8fa704.png";